import { IconButton } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import CloseIcon from "@mui/icons-material/Close";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import "./Help.css";

const HelpButtonModal = ({ open, setOpen }) => {
 const handleClose = () => {
  setOpen(false);
 };

 return (
  <Dialog sx={{ zIndex: 4000 }} maxWidth="xl" open={open} onClose={handleClose}>
   <DialogTitle
    sx={{
     display: "flex",
     flexDirection: "row",
     alignItems: "center",
     justifyContent: "flex-end",
     padding: "4px 4px 0px 0px",
     background: "var(--broward-blue)",
    }}
   >
    <IconButton
     aria-label="close"
     aria-haspopup="true"
     color="inherit"
     onClick={handleClose}
    >
     <CloseIcon sx={{ color: "white" }} fontSize="medium" />
    </IconButton>
   </DialogTitle>
   <DialogContent
    sx={{
     border: "44px solid var(--broward-blue)",
     borderTop: "none",
     padding: "0px 0px !important",
     overflow: "none",
    }}
   >
    <DialogContentText></DialogContentText>
    <div className="video-wrapper">
     <video className="video-element" controls>
      <source
       src="https://video.wixstatic.com/video/169f01_4158abd7655a423ebab24aa5e9b6576e/1080p/mp4/file.mp4"
       type="video/mp4"
      />
      Sorry, your browser doesn't support videos.
     </video>
    </div>
   </DialogContent>
  </Dialog>
 );
};

export default HelpButtonModal;
